import { Component, OnInit, OnDestroy } from '@angular/core';
import { Response } from '@angular/http';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs/Rx';
import { EventManager, ParseLinks, PaginationUtil, JhiLanguageService, AlertService } from 'ng-jhipster';

import { MarketdateBooth } from './marketdate-booth.model';
import { MarketdateBoothService } from './marketdate-booth.service';
import { ITEMS_PER_PAGE, Principal } from '../../shared';
import { PaginationConfig } from '../../blocks/config/uib-pagination.config';

@Component({
    selector: 'jhi-marketdate-booth',
    templateUrl: './marketdate-booth.component.html'
})
export class MarketdateBoothComponent implements OnInit, OnDestroy {
marketdateBooths: MarketdateBooth[];
    currentAccount: any;
    eventSubscriber: Subscription;
    currentSearch: string;

    constructor(
        private jhiLanguageService: JhiLanguageService,
        private marketdateBoothService: MarketdateBoothService,
        private alertService: AlertService,
        private eventManager: EventManager,
        private activatedRoute: ActivatedRoute,
        private principal: Principal
    ) {
        this.currentSearch = activatedRoute.snapshot.params['search'] ? activatedRoute.snapshot.params['search'] : '';
        this.jhiLanguageService.setLocations(['marketdateBooth', 'contractType', 'energyPriceType', 'marketdateBoothStatus']);
    }

    loadAll() {
        if (this.currentSearch) {
            this.marketdateBoothService.search({
                query: this.currentSearch,
                }).subscribe(
                    (res: Response) => this.marketdateBooths = res.json(),
                    (res: Response) => this.onError(res.json())
                );
            return;
       }
        this.marketdateBoothService.query().subscribe(
            (res: Response) => {
                this.marketdateBooths = res.json();
                this.currentSearch = '';
            },
            (res: Response) => this.onError(res.json())
        );
    }

    search(query) {
        if (!query) {
            return this.clear();
        }
        this.currentSearch = query;
        this.loadAll();
    }

    clear() {
        this.currentSearch = '';
        this.loadAll();
    }
    ngOnInit() {
        this.loadAll();
        this.principal.identity().then((account) => {
            this.currentAccount = account;
        });
        this.registerChangeInMarketdateBooths();
    }

    ngOnDestroy() {
        this.eventManager.destroy(this.eventSubscriber);
    }

    trackId(index: number, item: MarketdateBooth) {
        return item.id;
    }
    registerChangeInMarketdateBooths() {
        this.eventSubscriber = this.eventManager.subscribe('marketdateBoothListModification', (response) => this.loadAll());
    }

    private onError(error) {
        this.alertService.error(error.message, null, null);
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/marketdate-booth/marketdate-booth.component.ts